"use strict";

var _taggedTemplateLiteral = require("/usr/local/src/bitcoincom-notary/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.object.define-property");

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n        align-items: center;\n        text-align: center;\n      "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n          padding: ", "px ", "px;\n        "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n          padding: ", "px ", "px;\n        "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n        padding: ", "px;\n\n        ", "\n\n        ", "\n      "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    overflow: visible;\n    position: relative;\n    z-index: 1;\n    display: flex;\n    flex: 1;\n    flex-direction: ", ";\n    justify-content: space-between;\n    margin: ", "px;\n    box-sizing: border-box;\n    border-radius: ", "px;\n    background: ", ";\n\n    min-width: 269px;\n\n    &::before {\n      position: absolute;\n      z-index: -1;\n      top: 0;\n      left: 0;\n      bottom: 0;\n      right: 0;\n      content: \"\";\n      height: 100%;\n      width: 100%;\n      box-shadow: ", ";\n    }\n\n    ", "\n\n    ", "\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = __importStar(require("styled-components"));

var bitcoincom_pkg_theme_1 = require("@bitcoin-portal/bitcoincom-pkg-theme");

exports.StyledCard = styled_components_1["default"].div(_templateObject(), function (_ref) {
  var theme = _ref.theme,
      padded = _ref.padded,
      centered = _ref.centered,
      _ref$direction = _ref.direction,
      direction = _ref$direction === void 0 ? "column" : _ref$direction;
  return styled_components_1.css(_templateObject2(), direction, theme.spacing.unit * 2, theme.border.radius.medium, bitcoincom_pkg_theme_1.colors.solid.white, theme.shadows.boxShadow.card, padded && styled_components_1.css(_templateObject3(), theme.spacing.unit * 2, bitcoincom_pkg_theme_1.media.sm(_templateObject4(), theme.spacing.unit * 4, theme.spacing.unit * 3), bitcoincom_pkg_theme_1.media.md(_templateObject5(), theme.spacing.unit * 7, theme.spacing.unit * 4)), centered && styled_components_1.css(_templateObject6()));
});
exports["default"] = {};